export default __webpack_public_path__ + "static/media/a4size4.e0c2a173.png";